/**
 * Created by wumengqiang on 16/8/9.
 */
/*
    公用函数库
 */

export const Common = {
  getParamObj: getParamObj,
  formConfig: formConfig,
  isElement: isElement,
  // setRootFontSize: setRootFontSize(),
  isWeixin: isWeixin,
  isMerchantApp: isMerchantApp, // 判断农家掌柜app
  isAssistantApp: isAssistantApp, // 判断农家助手app
  setShareInfo: setShareInfo, // 微信分享
  log: log,
  navigate: navigate, // 微信, 腾讯导航
  tencentNavigate: tencentNavigate, // 腾讯导航
  getAddress: getAddress, // 获取详细地址
  setTitle: setTitle,
  requestParams: requestParams,
  objToForm: objToForm, // obj to multipart/form-data格式
  objToUrlencode: objToUrlencode, // obj to application/x-www-form-urlencode格式
  setStrFormat: setStrFormat() // 使得format函数生效
}

// if (typeof exports === 'object') {
//   module.exports = Common;
// } else if (typeof define !== 'undefined') {
//   define(function () {
//     return Common;
//   })
// } else if (typeof window === 'object') {
//   window.Common = Common;
// }

/**
 * 设置/获取地址栏参数
 */
/* eslint-disable no-undef */
function requestParams () {
  var args = {}
  var data = null
  var urlData = location.search
  var arrData
  if (arguments.length === 1) {
    data = arguments[0]
    if (typeof data === 'string') {
      var arr = this.location()
      args = arr[data] || ''
    } else if (typeof data === 'object') {
      if (urlData.indexOf('?') > -1) {
        var oldLocation = this.location()
        var newLocation = $.extend(oldLocation, data)
        args = '?' + $.param(newLocation)
      } else {
        args = '?' + $.param(data)
      }
    }
  } else if (arguments.length === 2) {
    if (arguments[1] === '') {
      args = this.location()
      if (args[arguments[0]]) {
        delete args[arguments[0]]
      }
      args = $.isEmptyObject(args) ? '' : ('?' + $.param(args))
    } else {
      args[arguments[0]] = arguments[1]
      args = this.location(args)
    }
  } else {
    urlData = urlData.replace('?', '')
    if (urlData.indexOf('&') > -1) {
      arrData = urlData.split('&')
      arrData.forEach(function (n, i) {
        if (n.indexOf('=') > -1) {
          n = n.split('=')
          args[n[0]] = decodeURIComponent((n[1] + '').replace(/\+/ig, ' '))
        } else {
          args[n] = ''
        }
      })
    } else {
      if (urlData.indexOf('=') > -1) {
        arrData = urlData.split('=')
        args[arrData[0]] = decodeURIComponent((arrData[1] + '').replace(/\+/ig, ' '))
      } else {
        args[urlData] = ''
      }
    }
  }
  return args
}
/* eslint-enable */

// 获取url中的参数并将其转化为对象
function getParamObj () {
  var res = location.search.split(/[?=&]/)
  var search = {}
  for (var i = 1, len = res.length; i < len; i += 2) {
    search[res[i]] = res[i + 1]
  }
  return search
}

// 增加format函数到String.prototype中
function setStrFormat () {
  if (!String.prototype.format) {
    /* eslint-disable-next-line */
    String.prototype.format = function () {
      var args = arguments
      return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] !== 'undefined' ? args[number] : ''
      })
    }
  }
}

function isElement (o) {
  return (
    typeof HTMLElement === 'object' ? o instanceof HTMLElement : o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string' // DOM2
  )
}

function formConfig ($httpProvider) {
  // Intercept POST requests, convert to standard form encoding
  $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded'
  // $httpProvider.defaults.headers.get["Content-Type"] = "application/x-www-form-urlencoded";
  $httpProvider.defaults.transformRequest.unshift(function (data, headersGetter) {
    var key
    var result = []
    if (toString.call(data) === '[object Object]') {
      for (key in data) {
        if (data.hasOwnProperty(key)) {
          var value = data[key]
          if (['[object Object]', '[object Array]'].indexOf(toString.call(value)) !== -1) {
            value = JSON.stringify(value)
          }
          result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
        }
      }
      return result.join('&')
    } else {
      return data
    }
  })
}

/* @baseWidth 基础宽度, 默认375
 *
 */
// function setRootFontSize () {
//   var tid
//   var called = false
//   var options
//
//   /*
//    * baseWidth 设计稿宽度
//    * opt {
//    *      landscape: boolean, // 表示是否在横屏是进行font-size切换
//    * }
//    *
//    */
//   function refreshRem (baseWidth, opt) {
//     baseWidth = baseWidth || 375
//     options = opt || {}
//     var direction = window.innerHeight >= window.innerWidth ? 'portrait' : 'landscape'
//
//     var size = window.innerWidth * 100 / baseWidth
//     // alert(window.innerWidth + ' ' + window.innerHeight +  '' + baseWidth + ' ' + size + ' ' +window.devicePixelRatio);
//
//     if (window.innerWidth > 900 && window.innerWidth > window.innerHeight) {
//       size = 750 / baseWidth * 100
//     } else if (window.innerWidth > 900 && window.innerWidth < window.innerHeight && window.devicePixelRatio > 1) {
//       size = window.innerWidth * 100 / baseWidth / window.devicePixelRatio
//     }
//     document.querySelector('html').style['font-size'] = size + 'px'
//     document.querySelector('body').style['font-size'] = size + 'px'
//
//     if (!called) {
//       window.addEventListener('resize', function () {
//         if (tid) {
//           clearTimeout(tid)
//         }
//         if (Math.abs(window.innerHeight - window.innerWidth) < 100) {
//           // fixbug  微信bug 旋转后 window.innerHeight 323  window.innerWidth 375
//           tid = setTimeout(function () {
//             refreshRem(baseWidth)
//           }, 100)
//           return
//         }
//
//         var curDirection = window.innerHeight >= window.innerWidth ? 'portrait' : 'landscape'
//         console.log(options.landscape, curDirection, window.innerWidth, window.innerHeight)
//         // 如果options.landscape为false,表示横屏时不进行font-size计算
//         if (options.landscape === false && curDirection === 'landscape') {
//           return
//         }
//
//         if (curDirection !== direction) {
//           tid = setTimeout(function () {
//             refreshRem(baseWidth)
//           }, 100)
//           direction = curDirection
//         }
//       }, false)
//       // window.addEventListener('pageshow', function (e) {
//       //    if (e.persisted) {
//       //        if (tid) clearTimeout(tid);
//       //
//       //        tid = setTimeout(function(){
//       //            refreshRem(baseWidth);
//       //        }, 300);
//       //    }
//       // }, false);
//     }
//     called = true
//   }
//
//   return refreshRem
// }

// 表示是微信且不是企业微信
function isWeixin () {
  return !!navigator.userAgent.match(/MicroMessenger/i) && !navigator.userAgent.match(/wxwork/i)
}

// 设置qq分享， 微信分享
function setShareInfo (shareInfo) {
  if (window.setShareInfo) {
    window.setShareInfo({
      title: shareInfo.title,
      summary: shareInfo.desc,
      pic: shareInfo.imgUrl,
      url: shareInfo.link
    })
  }

  if (window.wx && window.WeChat) {
    /* eslint-disable-next-line */
    return new window.WeChat(window.wx, shareInfo)
  }
}

function log (obj) {
  console.log(JSON.stringify(obj, null, 4))
}

/* 首先尝试微信导航, 然后尝试腾讯网页导航
 *  @param navInfo  导航相关信息
 *      {
 *          address: '', //详细信息
 *          lnglat: {
 *              lng: '', // 经度
 *              lat: '', //纬度
 *          },
 *          name: '', // 目的地名称
 *
 *
 */
function navigate (navInfo) {
  var isWeixin = navigator.userAgent.match(/MicroMessenger/i)
  if (isWeixin && window.wx) {
    // 判定为微信网页
    try {
      /* eslint-disable-next-line */
      wx.openLocation({
        latitude: parseFloat(navInfo.lnglat.lat), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(navInfo.lnglat.lng), // 经度，浮点数，范围为180 ~ -180。
        name: navInfo.name, // 位置名
        address: navInfo.address, // 地址详情说明
        scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
        fail: function () {
          tencentNavigate(navInfo)
        }
      })
    } catch (e) {
      tencentNavigate(navInfo)
    }
  } else {
    tencentNavigate(navInfo)
  }
}

/* 腾讯网页导航
 *  @param navInfo  导航相关信息
 *      {
 *          address: '', //详细信息
 *          lnglat: {
 *              lng: '', // 经度
 *              lat: '', //纬度
 *          },
 *          name: '', // 目的地名称
 *
 *
 */
function tencentNavigate (navInfo) {
  var url = encodeURI('//apis.map.qq.com/uri/v1/routeplan?type=drive&to=' +
    navInfo.address + navInfo.name + '&tocoord=' + navInfo.lnglat.lat +
    '%2C' + navInfo.lnglat.lng + '&referer=nongjia')
  window.location.href = url
}

function getAddress (address) {
  var province = ['北京', '天津', '上海'].indexOf(address.province) !== -1 ? '' : address.province
  return (province + address.city + address.county + address.detail_address) || address.province
}

function setTitle (title) {
  document.title = title
  var i = document.createElement('iframe')
  i.src = '//m.baidu.com/favicon.ico'
  i.style.display = 'none'
  i.onload = function () {
    setTimeout(function () {
      i.remove()
    }, 9)
  }
  i.onerror = function () {
    setTimeout(function () {
      i.remove()
    }, 9)
  }
  document.body.appendChild(i)
}

// object to multipart/form-data 格式
function objToForm (obj) {
  var form = new FormData()
  Object.keys(obj).forEach(function (key, item) {
    var value = obj[key]
    if (['[object Object]', '[object Array]'].indexOf(toString.call(value)) !== -1) {
      value = JSON.stringify(value)
    }
    form.append(key, value)
  })
  return form
}

// object to application/x-www-form-urlencoded
function objToUrlencode (data) {
  var key
  var result = []
  if (toString.call(data) === '[object Object]') {
    for (key in data) {
      if (data.hasOwnProperty(key)) {
        var value = data[key]
        if (['[object Object]', '[object Array]'].indexOf(toString.call(value)) !== -1) {
          value = JSON.stringify(value)
        }
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
      }
    }
    return result.join('&')
  } else {
    return data
  }
}

function isMerchantApp () {
  var reg = /merchant\/android|merchant\/ios/
  var userAgent = navigator.userAgent
  return reg.test(userAgent)
}

function isAssistantApp () {
  var reg = /assistant\/android|assistant\/ios/
  var userAgent = navigator.userAgent
  return reg.test(userAgent)
}



// WEBPACK FOOTER //
// ./src/assets/js/huangye/common.js